/**
 * Friendly Captcha: explain a widget that cannot reach frcapi.com.
 *
 * SDK 1.1.3 gives up after five connection attempts (about 70 s in total, with
 * fallback hosts) and dispatches a bubbling `frc:widget.error` on the widget element.
 * Its own text is short and English. For a `network_error` this adds the page-language
 * explanation from the widget's `data-error-message` (set by the Fluid partials) right
 * below the widget. `frc:widget.reset` removes it again; the SDK fires that itself when
 * the browser reports it is back online.
 */
const NOTICE_CLASS = 'frc-captcha-notice';

const widgetOf = (event) => {
  const target = event.target;
  return target instanceof HTMLElement && target.classList.contains('frc-captcha') ? target : null;
};

const noticeOf = (widget) => {
  const next = widget.nextElementSibling;
  return next && next.classList.contains(NOTICE_CLASS) ? next : null;
};

document.addEventListener('frc:widget.error', (event) => {
  const widget = widgetOf(event);
  const code = event.detail && event.detail.error ? event.detail.error.code : '';
  const message = widget ? widget.dataset.errorMessage : '';
  if (!widget || !message || code !== 'network_error') return;
  let notice = noticeOf(widget);
  if (!notice) {
    notice = document.createElement('div');
    notice.className = NOTICE_CLASS + ' text-danger small mt-2';
    notice.setAttribute('role', 'alert');
    widget.insertAdjacentElement('afterend', notice);
  }
  notice.textContent = message;
});

document.addEventListener('frc:widget.reset', (event) => {
  const widget = widgetOf(event);
  const notice = widget ? noticeOf(widget) : null;
  if (notice) notice.remove();
});
